import React from "react";
import SearchResultPage from "../../../templates/search-results-template";
import { useGlobalStore } from "@store/globalStore"

const SearchResultCommLettings = (props) => {
    const currencyType = useGlobalStore((state) => state.currencyType)
    const fullpath = props.location.pathname
    const location = props.location
    const fullpathone = props.location

    return (
        <React.Fragment>
            <SearchResultPage
                locationname="/commercial-properties/for-rent/"
                pcategorytype="commercial"
                ptype="lettings"
                ptypetag="for-rent"
                pstatustype="To Let"
                fullpathone={fullpathone}
                fullpathname={fullpath}
                currencyType={currencyType}
                {...props}
            />
        </React.Fragment>
    );
};

export default SearchResultCommLettings;